import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0bd1435e&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0bd1435e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Users/pongping/htdocs/ufs896@vip/mexicano/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1435e",
  null
  
)

export default component.exports